import { ComponentIds } from './constants/componentIds';

export const toCaps = (str: string) => {
  const capitalizedWords = str.split('_').map((word: string) => {
    return `${word.charAt(0).toUpperCase()}${word.slice(1)}`;
  });
  return capitalizedWords.join(' ');
};

export const scrollToSection = (
  ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
) => {
  const val: string | null = ev.currentTarget.getAttribute('data-link-id');
  if (val) {
    const el = document.getElementById(val.split(' ').join(''));
    const appHeaderEl = document.getElementById(
      ComponentIds.NORA_APP_HEADER_ID,
    );
    if (el) {
      window.scrollTo({
        // Subtracting the height of Header box to reset top to bit above of the box position
        top: appHeaderEl
          ? el.offsetTop - appHeaderEl?.offsetHeight * 1.5
          : el.offsetTop,
        behavior: 'smooth',
      });
    }
  }
};

/**
 * Helper function to execute async operation and catch errors if thrown.
 * @param promise
 */
export const attempt = (promise: Promise<any>): Promise<any[]> => {
  return promise.then(result => [result, null]).catch(error => [null, error]);
};

export const isTheBoolEmpty = (value?: boolean): boolean => {
  return value === undefined || value === null;
};
